import * as types from '../actions/error-actions';

const initialState = {};

const errorReducer = function (state = initialState, action) {

	switch (action.type) {
		case types.GET_USER_ERROR:
			return Object.assign({}, state, {
				getUserError: action.error
			});
			break;

		case types.REQUEST_SMS_ERROR:
			return Object.assign({}, state, {
				requestSmsError: action.error
			});
			break;

		case types.INVALID_VALIDATION_CODE:
			return Object.assign({}, state, {
				invalidValidationCode: action.error
			});
			break;

		case types.SUBSCRIBE_MSISDN_ERROR:
			return Object.assign({}, state, {
				subscribeMsisdnError: action.error
			});
			break;

		case types.SUBSCRIBE_NO_CREDITS:
			return Object.assign({}, state, {
				subscribeNoCredits: action.error
			});
			break;
			
		case types.SUBSCRIBE_GENERAL_ERROR:
			return Object.assign({}, state, {
				subscribeGeneralError: action.error
			});
			break;
	}

	return state;
};

export default errorReducer;


// WEBPACK FOOTER //
// ./src/reducers/error-reducer.js